const ServiceOutageNavigator = () => import('_navigations/Home/ServiceOutage/ServiceOutageNavigator')

const ServiceOutageScreen = () => import('_screens/Home/ServiceOutage/ServiceOutageScreen')

const ServiceOutageRoutes = [
    {
        path: 'service-outage',
        component: ServiceOutageNavigator,
        children: [
            {
                path: '',
                name: 'ServiceOutage',
                component: ServiceOutageScreen,
                meta: {
                    screenOptions: {
                        title: 'Отключение услуг',
                    },
                },
            },
        ],
    },
]

export default ServiceOutageRoutes
